import { Modal, Button, Table } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import { getStockValidationColumns } from "./columnDefinitions";

const StockValidationModal = ({
  isVisible,
  setIsVisible,
  setSelectedRowKey,
  setShowInputFields,
  setSelectedQuantity,
  setSelectedTotalQuantity,
  stockValidationData,
  activeTabKey,
}) => {
  const columns = getStockValidationColumns(activeTabKey);

  return (
    <Modal
      open={isVisible}
      closable={false}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={() => {
            setIsVisible(false);
            setSelectedRowKey(null);
            setShowInputFields(false);
            setSelectedQuantity(0);
            setSelectedTotalQuantity(0);
          }}
        >
          OK
        </Button>,
      ]}
      width={"45vw"}
      centered
    >
      <p style={{ fontWeight: 500, paddingBottom: "2vh", textAlign: "center", color: "red" }}>
        <WarningOutlined style={{ color: "orange", fontSize: "1.2rem" }} />
        This component cannot be added due to insufficient stock
      </p>
      <Table
        tableLayout="fixed"
        style={{
          width: "100%",
          overflowY: "auto",
          borderRadius: "10px",
          padding: "0",
          height: "25vh",
          background: "#fff",
          maxHeight: "25vh",
          display: "block",
        }}
        size="small"
        pagination={false}
        dataSource={stockValidationData || []}
        sticky
        className="sm-stock-table-BOM"
        columns={columns}
      />
    </Modal>
  );
};

export default StockValidationModal;
